export function convertObjectToURI(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}
export function emitHeightAdjustEvent(height) {
    if (height === void 0) { height = document.body.scrollHeight; }
    if (height !== document.body.scrollHeight) {
        height = document.body.scrollHeight + height;
    }
    window.parent.postMessage({ name: "height", value: height + "px" }, "*");
}
export function imgUrl(url, width, height) {
    return url;
}
export function getUrlParams() {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams = appendDocumentReferrer(urlParams);
    return urlParams;
}
export function appendDocumentReferrer(urlParams) {
    // try to read the iframe parent url
    if (!Boolean(urlParams.get("page_url"))) {
        var url = window.location != window.parent.location
            ? document.referrer.split("/")[2]
            : document.location.host + document.location.pathname;
        urlParams.set("page_url", url);
    }
    return urlParams;
}
